import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

import IconAlert from "../components/icons/IconAlert.vue";

export default new Vuetify({
  icons: {
    values: {
      iconalert: {
        component: IconAlert
      }
    }
  }
});
